// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/gif;base64,R0lGODlhCgAKAJECAAAAAP///////wAAACH/C05FVFNDQVBFMi4wAwEAAAAh/wtYTVAgRGF0YVhNUDw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6OEI5RDc5MTFDNkE2MTFFM0JCMDZEODI2QTI4MzJBOTIiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6OEI5RDc5MTBDNkE2MTFFM0JCMDZEODI2QTI4MzJBOTIiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoTWFjaW50b3NoKSI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuZGlkOjAyODAxMTc0MDcyMDY4MTE4MDgzQzNDMjA5MzREQ0ZDIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjAyODAxMTc0MDcyMDY4MTE4MDgzQzNDMjA5MzREQ0ZDIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+Af/+/fz7+vn49/b19PPy8fDv7u3s6+rp6Ofm5eTj4uHg397d3Nva2djX1tXU09LR0M/OzczLysnIx8bFxMPCwcC/vr28u7q5uLe2tbSzsrGwr66trKuqqainpqWko6KhoJ+enZybmpmYl5aVlJOSkZCPjo2Mi4qJiIeGhYSDgoGAf359fHt6eXh3dnV0c3JxcG9ubWxramloZ2ZlZGNiYWBfXl1cW1pZWFdWVVRTUlFQT05NTEtKSUhHRkVEQ0JBQD8+PTw7Ojk4NzY1NDMyMTAvLi0sKyopKCcmJSQjIiEgHx4dHBsaGRgXFhUUExIREA8ODQwLCgkIBwYFBAMCAQAAIfkEBQoAAgAsAAAAAAoACgAAAhWEERkn7W3ei7KlagMWF/dKgYeyGAUAIfkEBQoAAgAsAAAAAAoACgAAAg+UYwLJ7RnQm7QmsCyVKhUAIfkEBQoAAgAsAAAAAAoACgAAAhCUYgLJHdiinNSAVfOEKoUCACH5BAUKAAIALAAAAAAKAAoAAAIRVISAdusPo3RAzYtjaMIaUQAAIfkEBQoAAgAsAAAAAAoACgAAAg+MDiem7Q8bSLFaG5il6xQAIfkEBQoAAgAsAAAAAAoACgAAAg+UYRLJ7QnQm7SmsCyVKhUAIfkEBQoAAgAsAAAAAAoACgAAAhCUYBLJDdiinNSEVfOEKoECACH5BAUKAAIALAAAAAAKAAoAAAIRFISBdusPo3RBzYsjaMIaUQAAOw==", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ReactCrop {
  position: relative;
  display: inline-block;
  cursor: crosshair;
  overflow: hidden;
  max-width: 100%;
}

.ReactCrop:focus {
  outline: none;
}

.ReactCrop--disabled,
.ReactCrop--locked {
  cursor: inherit;
}

.ReactCrop__image {
  display: block;
  max-width: 100%;
  touch-action: none;
}

.ReactCrop__crop-selection {
  position: absolute;
  top: 0;
  left: 0;
  transform: translate3d(0, 0, 0);
  box-sizing: border-box;
  cursor: move;
  box-shadow: 0 0 0 9999em rgba(0, 0, 0, 0.5);
  touch-action: none;
  border: 1px solid;
  border-image-source: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  border-image-slice: 1;
  border-image-repeat: repeat;
}

.ReactCrop--disabled .ReactCrop__crop-selection {
  cursor: inherit;
}

.ReactCrop--circular-crop .ReactCrop__crop-selection {
  border-radius: 50%;
  box-shadow: 0px 0px 1px 1px #fff, 0 0 0 9999em rgba(0, 0, 0, 0.5);
}

.ReactCrop--invisible-crop .ReactCrop__crop-selection {
  display: none;
}

.ReactCrop__rule-of-thirds-vt::before,
.ReactCrop__rule-of-thirds-vt::after,
.ReactCrop__rule-of-thirds-hz::before,
.ReactCrop__rule-of-thirds-hz::after {
  content: '';
  display: block;
  position: absolute;
  background-color: rgba(255, 255, 255, 0.4);
}

.ReactCrop__rule-of-thirds-vt::before,
.ReactCrop__rule-of-thirds-vt::after {
  width: 1px;
  height: 100%;
}

.ReactCrop__rule-of-thirds-vt::before {
  left: 33.3333%;
  left: calc(100% / 3);
}

.ReactCrop__rule-of-thirds-vt::after {
  left: 66.6666%;
  left: calc(100% / 3 * 2);
}

.ReactCrop__rule-of-thirds-hz::before,
.ReactCrop__rule-of-thirds-hz::after {
  width: 100%;
  height: 1px;
}

.ReactCrop__rule-of-thirds-hz::before {
  top: 33.3333%;
  top: calc(100% / 3);
}

.ReactCrop__rule-of-thirds-hz::after {
  top: 66.6666%;
  top: calc(100% / 3 * 2);
}

.ReactCrop__drag-handle {
  position: absolute;
}

.ReactCrop__drag-handle::after {
  position: absolute;
  content: '';
  display: block;
  width: 10px;
  height: 10px;
  background-color: rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.7);
  box-sizing: border-box;
  outline: 1px solid transparent;
}

.ReactCrop .ord-nw {
  top: 0;
  left: 0;
  margin-top: -5px;
  margin-left: -5px;
  cursor: nw-resize;
}

.ReactCrop .ord-nw::after {
  top: 0;
  left: 0;
}

.ReactCrop .ord-n {
  top: 0;
  left: 50%;
  margin-top: -5px;
  margin-left: -5px;
  cursor: n-resize;
}

.ReactCrop .ord-n::after {
  top: 0;
}

.ReactCrop .ord-ne {
  top: 0;
  right: 0;
  margin-top: -5px;
  margin-right: -5px;
  cursor: ne-resize;
}

.ReactCrop .ord-ne::after {
  top: 0;
  right: 0;
}

.ReactCrop .ord-e {
  top: 50%;
  right: 0;
  margin-top: -5px;
  margin-right: -5px;
  cursor: e-resize;
}

.ReactCrop .ord-e::after {
  right: 0;
}

.ReactCrop .ord-se {
  bottom: 0;
  right: 0;
  margin-bottom: -5px;
  margin-right: -5px;
  cursor: se-resize;
}

.ReactCrop .ord-se::after {
  bottom: 0;
  right: 0;
}

.ReactCrop .ord-s {
  bottom: 0;
  left: 50%;
  margin-bottom: -5px;
  margin-left: -5px;
  cursor: s-resize;
}

.ReactCrop .ord-s::after {
  bottom: 0;
}

.ReactCrop .ord-sw {
  bottom: 0;
  left: 0;
  margin-bottom: -5px;
  margin-left: -5px;
  cursor: sw-resize;
}

.ReactCrop .ord-sw::after {
  bottom: 0;
  left: 0;
}

.ReactCrop .ord-w {
  top: 50%;
  left: 0;
  margin-top: -5px;
  margin-left: -5px;
  cursor: w-resize;
}

.ReactCrop .ord-w::after {
  left: 0;
}

.ReactCrop__disabled .ReactCrop__drag-handle {
  cursor: inherit;
}

.ReactCrop__drag-bar {
  position: absolute;
}

.ReactCrop__drag-bar.ord-n {
  top: 0;
  left: 0;
  width: 100%;
  height: 6px;
  margin-top: -3px;
}

.ReactCrop__drag-bar.ord-e {
  right: 0;
  top: 0;
  width: 6px;
  height: 100%;
  margin-right: -3px;
}

.ReactCrop__drag-bar.ord-s {
  bottom: 0;
  left: 0;
  width: 100%;
  height: 6px;
  margin-bottom: -3px;
}

.ReactCrop__drag-bar.ord-w {
  top: 0;
  left: 0;
  width: 6px;
  height: 100%;
  margin-left: -3px;
}

.ReactCrop--new-crop .ReactCrop__drag-bar,
.ReactCrop--new-crop .ReactCrop__drag-handle,
.ReactCrop--fixed-aspect .ReactCrop__drag-bar {
  display: none;
}

.ReactCrop--fixed-aspect .ReactCrop__drag-handle.ord-n,
.ReactCrop--fixed-aspect .ReactCrop__drag-handle.ord-e,
.ReactCrop--fixed-aspect .ReactCrop__drag-handle.ord-s,
.ReactCrop--fixed-aspect .ReactCrop__drag-handle.ord-w {
  display: none;
}

@media (pointer: coarse) {
  .ReactCrop .ord-n,
  .ReactCrop .ord-e,
  .ReactCrop .ord-s,
  .ReactCrop .ord-w {
    display: none;
  }

  .ReactCrop__drag-handle {
    width: 24px;
    height: 24px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/general/image-cropper/src/ReactCrop.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,+BAA+B;EAC/B,sBAAsB;EACtB,YAAY;EACZ,2CAA2C;EAC3C,kBAAkB;EAClB,iBAAiB;EACjB,4DAA43D;EAC53D,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,iEAAiE;AACnE;;AAEA;EACE,aAAa;AACf;;AAEA;;;;EAIE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;;EAEE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,wBAAwB;AAC1B;;AAEA;;EAEE,WAAW;EACX,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,0CAA0C;EAC1C,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,MAAM;EACN,OAAO;EACP,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,MAAM;EACN,OAAO;AACT;;AAEA;EACE,MAAM;EACN,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,MAAM;AACR;;AAEA;EACE,MAAM;EACN,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,MAAM;EACN,QAAQ;AACV;;AAEA;EACE,QAAQ;EACR,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,SAAS;EACT,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;EACT,OAAO;EACP,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,OAAO;AACT;;AAEA;EACE,QAAQ;EACR,OAAO;EACP,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,MAAM;EACN,OAAO;EACP,WAAW;EACX,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,QAAQ;EACR,MAAM;EACN,UAAU;EACV,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,OAAO;EACP,WAAW;EACX,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,MAAM;EACN,OAAO;EACP,UAAU;EACV,YAAY;EACZ,iBAAiB;AACnB;;AAEA;;;EAGE,aAAa;AACf;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;EACE;;;;IAIE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":[".ReactCrop {\r\n  position: relative;\r\n  display: inline-block;\r\n  cursor: crosshair;\r\n  overflow: hidden;\r\n  max-width: 100%;\r\n}\r\n\r\n.ReactCrop:focus {\r\n  outline: none;\r\n}\r\n\r\n.ReactCrop--disabled,\r\n.ReactCrop--locked {\r\n  cursor: inherit;\r\n}\r\n\r\n.ReactCrop__image {\r\n  display: block;\r\n  max-width: 100%;\r\n  touch-action: none;\r\n}\r\n\r\n.ReactCrop__crop-selection {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  transform: translate3d(0, 0, 0);\r\n  box-sizing: border-box;\r\n  cursor: move;\r\n  box-shadow: 0 0 0 9999em rgba(0, 0, 0, 0.5);\r\n  touch-action: none;\r\n  border: 1px solid;\r\n  border-image-source: url(data:image/gif;base64,R0lGODlhCgAKAJECAAAAAP///////wAAACH/C05FVFNDQVBFMi4wAwEAAAAh/wtYTVAgRGF0YVhNUDw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6OEI5RDc5MTFDNkE2MTFFM0JCMDZEODI2QTI4MzJBOTIiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6OEI5RDc5MTBDNkE2MTFFM0JCMDZEODI2QTI4MzJBOTIiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoTWFjaW50b3NoKSI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuZGlkOjAyODAxMTc0MDcyMDY4MTE4MDgzQzNDMjA5MzREQ0ZDIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjAyODAxMTc0MDcyMDY4MTE4MDgzQzNDMjA5MzREQ0ZDIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+Af/+/fz7+vn49/b19PPy8fDv7u3s6+rp6Ofm5eTj4uHg397d3Nva2djX1tXU09LR0M/OzczLysnIx8bFxMPCwcC/vr28u7q5uLe2tbSzsrGwr66trKuqqainpqWko6KhoJ+enZybmpmYl5aVlJOSkZCPjo2Mi4qJiIeGhYSDgoGAf359fHt6eXh3dnV0c3JxcG9ubWxramloZ2ZlZGNiYWBfXl1cW1pZWFdWVVRTUlFQT05NTEtKSUhHRkVEQ0JBQD8+PTw7Ojk4NzY1NDMyMTAvLi0sKyopKCcmJSQjIiEgHx4dHBsaGRgXFhUUExIREA8ODQwLCgkIBwYFBAMCAQAAIfkEBQoAAgAsAAAAAAoACgAAAhWEERkn7W3ei7KlagMWF/dKgYeyGAUAIfkEBQoAAgAsAAAAAAoACgAAAg+UYwLJ7RnQm7QmsCyVKhUAIfkEBQoAAgAsAAAAAAoACgAAAhCUYgLJHdiinNSAVfOEKoUCACH5BAUKAAIALAAAAAAKAAoAAAIRVISAdusPo3RAzYtjaMIaUQAAIfkEBQoAAgAsAAAAAAoACgAAAg+MDiem7Q8bSLFaG5il6xQAIfkEBQoAAgAsAAAAAAoACgAAAg+UYRLJ7QnQm7SmsCyVKhUAIfkEBQoAAgAsAAAAAAoACgAAAhCUYBLJDdiinNSEVfOEKoECACH5BAUKAAIALAAAAAAKAAoAAAIRFISBdusPo3RBzYsjaMIaUQAAOw==);\r\n  border-image-slice: 1;\r\n  border-image-repeat: repeat;\r\n}\r\n\r\n.ReactCrop--disabled .ReactCrop__crop-selection {\r\n  cursor: inherit;\r\n}\r\n\r\n.ReactCrop--circular-crop .ReactCrop__crop-selection {\r\n  border-radius: 50%;\r\n  box-shadow: 0px 0px 1px 1px #fff, 0 0 0 9999em rgba(0, 0, 0, 0.5);\r\n}\r\n\r\n.ReactCrop--invisible-crop .ReactCrop__crop-selection {\r\n  display: none;\r\n}\r\n\r\n.ReactCrop__rule-of-thirds-vt::before,\r\n.ReactCrop__rule-of-thirds-vt::after,\r\n.ReactCrop__rule-of-thirds-hz::before,\r\n.ReactCrop__rule-of-thirds-hz::after {\r\n  content: '';\r\n  display: block;\r\n  position: absolute;\r\n  background-color: rgba(255, 255, 255, 0.4);\r\n}\r\n\r\n.ReactCrop__rule-of-thirds-vt::before,\r\n.ReactCrop__rule-of-thirds-vt::after {\r\n  width: 1px;\r\n  height: 100%;\r\n}\r\n\r\n.ReactCrop__rule-of-thirds-vt::before {\r\n  left: 33.3333%;\r\n  left: calc(100% / 3);\r\n}\r\n\r\n.ReactCrop__rule-of-thirds-vt::after {\r\n  left: 66.6666%;\r\n  left: calc(100% / 3 * 2);\r\n}\r\n\r\n.ReactCrop__rule-of-thirds-hz::before,\r\n.ReactCrop__rule-of-thirds-hz::after {\r\n  width: 100%;\r\n  height: 1px;\r\n}\r\n\r\n.ReactCrop__rule-of-thirds-hz::before {\r\n  top: 33.3333%;\r\n  top: calc(100% / 3);\r\n}\r\n\r\n.ReactCrop__rule-of-thirds-hz::after {\r\n  top: 66.6666%;\r\n  top: calc(100% / 3 * 2);\r\n}\r\n\r\n.ReactCrop__drag-handle {\r\n  position: absolute;\r\n}\r\n\r\n.ReactCrop__drag-handle::after {\r\n  position: absolute;\r\n  content: '';\r\n  display: block;\r\n  width: 10px;\r\n  height: 10px;\r\n  background-color: rgba(0, 0, 0, 0.2);\r\n  border: 1px solid rgba(255, 255, 255, 0.7);\r\n  box-sizing: border-box;\r\n  outline: 1px solid transparent;\r\n}\r\n\r\n.ReactCrop .ord-nw {\r\n  top: 0;\r\n  left: 0;\r\n  margin-top: -5px;\r\n  margin-left: -5px;\r\n  cursor: nw-resize;\r\n}\r\n\r\n.ReactCrop .ord-nw::after {\r\n  top: 0;\r\n  left: 0;\r\n}\r\n\r\n.ReactCrop .ord-n {\r\n  top: 0;\r\n  left: 50%;\r\n  margin-top: -5px;\r\n  margin-left: -5px;\r\n  cursor: n-resize;\r\n}\r\n\r\n.ReactCrop .ord-n::after {\r\n  top: 0;\r\n}\r\n\r\n.ReactCrop .ord-ne {\r\n  top: 0;\r\n  right: 0;\r\n  margin-top: -5px;\r\n  margin-right: -5px;\r\n  cursor: ne-resize;\r\n}\r\n\r\n.ReactCrop .ord-ne::after {\r\n  top: 0;\r\n  right: 0;\r\n}\r\n\r\n.ReactCrop .ord-e {\r\n  top: 50%;\r\n  right: 0;\r\n  margin-top: -5px;\r\n  margin-right: -5px;\r\n  cursor: e-resize;\r\n}\r\n\r\n.ReactCrop .ord-e::after {\r\n  right: 0;\r\n}\r\n\r\n.ReactCrop .ord-se {\r\n  bottom: 0;\r\n  right: 0;\r\n  margin-bottom: -5px;\r\n  margin-right: -5px;\r\n  cursor: se-resize;\r\n}\r\n\r\n.ReactCrop .ord-se::after {\r\n  bottom: 0;\r\n  right: 0;\r\n}\r\n\r\n.ReactCrop .ord-s {\r\n  bottom: 0;\r\n  left: 50%;\r\n  margin-bottom: -5px;\r\n  margin-left: -5px;\r\n  cursor: s-resize;\r\n}\r\n\r\n.ReactCrop .ord-s::after {\r\n  bottom: 0;\r\n}\r\n\r\n.ReactCrop .ord-sw {\r\n  bottom: 0;\r\n  left: 0;\r\n  margin-bottom: -5px;\r\n  margin-left: -5px;\r\n  cursor: sw-resize;\r\n}\r\n\r\n.ReactCrop .ord-sw::after {\r\n  bottom: 0;\r\n  left: 0;\r\n}\r\n\r\n.ReactCrop .ord-w {\r\n  top: 50%;\r\n  left: 0;\r\n  margin-top: -5px;\r\n  margin-left: -5px;\r\n  cursor: w-resize;\r\n}\r\n\r\n.ReactCrop .ord-w::after {\r\n  left: 0;\r\n}\r\n\r\n.ReactCrop__disabled .ReactCrop__drag-handle {\r\n  cursor: inherit;\r\n}\r\n\r\n.ReactCrop__drag-bar {\r\n  position: absolute;\r\n}\r\n\r\n.ReactCrop__drag-bar.ord-n {\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 6px;\r\n  margin-top: -3px;\r\n}\r\n\r\n.ReactCrop__drag-bar.ord-e {\r\n  right: 0;\r\n  top: 0;\r\n  width: 6px;\r\n  height: 100%;\r\n  margin-right: -3px;\r\n}\r\n\r\n.ReactCrop__drag-bar.ord-s {\r\n  bottom: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 6px;\r\n  margin-bottom: -3px;\r\n}\r\n\r\n.ReactCrop__drag-bar.ord-w {\r\n  top: 0;\r\n  left: 0;\r\n  width: 6px;\r\n  height: 100%;\r\n  margin-left: -3px;\r\n}\r\n\r\n.ReactCrop--new-crop .ReactCrop__drag-bar,\r\n.ReactCrop--new-crop .ReactCrop__drag-handle,\r\n.ReactCrop--fixed-aspect .ReactCrop__drag-bar {\r\n  display: none;\r\n}\r\n\r\n.ReactCrop--fixed-aspect .ReactCrop__drag-handle.ord-n,\r\n.ReactCrop--fixed-aspect .ReactCrop__drag-handle.ord-e,\r\n.ReactCrop--fixed-aspect .ReactCrop__drag-handle.ord-s,\r\n.ReactCrop--fixed-aspect .ReactCrop__drag-handle.ord-w {\r\n  display: none;\r\n}\r\n\r\n@media (pointer: coarse) {\r\n  .ReactCrop .ord-n,\r\n  .ReactCrop .ord-e,\r\n  .ReactCrop .ord-s,\r\n  .ReactCrop .ord-w {\r\n    display: none;\r\n  }\r\n\r\n  .ReactCrop__drag-handle {\r\n    width: 24px;\r\n    height: 24px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
